'use client';
import ModalLayout from '@/containers/modal-layout';
import PublicHeader from '@/containers/public-header';
import { CartProvider } from '@/contexts/cart.context';
import CartBodyRightDrawer from '@/features/common/cart-body-right-drawer';
import { usePathname } from 'next/navigation';

export default function PublicLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const path = usePathname();
  const isLoginPage = path.includes('login');
  const isRootPage = path === '/';
  return (
    <CartProvider>
      <div className={`drawer lg:drawer-open drawer-end`}>
        <input id="cart-drawer" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content">
          <PublicHeader />
          <main className="flex-1 p-8 bg-[#f7f5f27d] h-[calc(100vh-64px)] overflow-y-auto">
            {children}
          </main>
        </div>
        {!isLoginPage && !isRootPage && (
          <div className="drawer-side z-50 ">
            <label
              htmlFor="cart-drawer"
              aria-label="close sidebar"
              className="drawer-overlay lg:hidden"
            ></label>
            <div className="menu bg-base-100 text-base-content min-h-full w-96 p-4">
              <CartBodyRightDrawer />
            </div>
          </div>
        )}
        <ModalLayout />
      </div>
    </CartProvider>
  );
}
